(function() {
  'use strict';
  var passive = POV.support.EventListenerOptions ? { passive: true } : false;
  var trigger = document.querySelector('[data-scroll-top]');
  var target = document.querySelector(trigger.getAttribute('data-scroll-target'));
  var header = document.querySelector('[data-section-id="header"]');

  var minView = 800;
  var threshold = 40;

  if (!trigger || !target || !header) return;

  var debounceScroll = debounce(handleScroll, 48);
  window.addEventListener('scroll', debounceScroll, passive);
  trigger.addEventListener('click', handleClick, false);

  function handleScroll() {
    var endOfPageReached = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - threshold);
    var isVisibile = window.scrollY > minView && !endOfPageReached;
    trigger.setAttribute('data-scroll-top', isVisibile);
    isVisibile 
      ? document.body.classList.add('scroll-top-visible') 
      : document.body.classList.remove('scroll-top-visible');
  }

  function handleClick() {
    var headerHeight = header.getBoundingClientRect().height;
    var scrollToY = target.getBoundingClientRect().top + window.scrollY - headerHeight;
    
    POV.support.ScrollBehavior
      ? window.scrollTo({ top: scrollToY, left: 0, behavior: 'smooth' })
      : window.scrollTo(0, scrollToY);
  }
})();
